const INITIAL_STATE = {
  empresaMaquinaList: [],
  empresaMaquina: null
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case 'EMPRESAMAQUINALIST_FETCH':
        return { ...state, empresaMaquinaList: action.payload }
      case 'EMPRESAMAQUINA_SET':
        return { ...state, empresaMaquina: action.payload }
      default:
        return state
    }
  }